import { render, staticRenderFns } from "./CardCurriculumAlignment.vue?vue&type=template&id=623f2234&scoped=true&"
import script from "./CardCurriculumAlignment.vue?vue&type=script&lang=js&"
export * from "./CardCurriculumAlignment.vue?vue&type=script&lang=js&"
import style0 from "./CardCurriculumAlignment.vue?vue&type=style&index=0&id=623f2234&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623f2234",
  null
  
)

export default component.exports